import { all, takeLatest } from "redux-saga/effects";
import {
  COUPON_LIST,
  COUPON_DETAILS,
  ADD_COUPON,
  UPDATE_COUPON,
  DELETE_COUPON,
} from "../actions/coupon.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getCouponList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "coupons/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* couponDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `coupons/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* addCoupon({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "coupons",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* updateCoupon({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `coupons/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteCoupon({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `coupons/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Coupon() {
  yield all([
    takeLatest(COUPON_LIST, getCouponList),
    takeLatest(COUPON_DETAILS, couponDetails),
    takeLatest(ADD_COUPON, addCoupon),
    takeLatest(UPDATE_COUPON, updateCoupon),
    takeLatest(DELETE_COUPON, deleteCoupon),
  ]);
}

export default Coupon;
